import { formatDistance, isValid } from "date-fns";

/**
 * Formats time until a final-exam unlock date, or null if the date is missing/invalid.
 */
export const formatExamUnlockDistance = (
	unlockDate: string | Date | null | undefined,
	options?: Parameters<typeof formatDistance>[2],
): string | null => {
	if (unlockDate == null || unlockDate === "") {
		return null;
	}

	const date = unlockDate instanceof Date ? unlockDate : new Date(unlockDate);
	if (!isValid(date)) {
		return null;
	}

	return formatDistance(date, new Date(), options);
};
